// extracted by mini-css-extract-plugin
export var emptyLabel = "Multiple_emptyLabel__Qne8C";
export var groupingLabel = "Multiple_groupingLabel__RdMY1";
export var groupingLabels = "Multiple_groupingLabels__YVsPD";
export var headerContainer = "Multiple_headerContainer__v4ijr";
export var md = "768px";
export var shared = "'../../../shared.module.css'";